import {
  type PlacementCandidate,
  PlacementCandidateScreeningStatus,
} from "../../../PlacementCandidate/types";
import { usePlacementRecruiterScreeningConfig } from "../../hooks/usePlacementRecruiterScreeningConfig";
import { RecruiterBookingFlowProvider } from "../../hooks/useRecruiterBookingFlowContext";
import { RecruiterScreeningCallCard } from "./RecruiterScreeningCallCard";
import { RecruiterScreeningUpskillingCallCard } from "./RecruiterScreeningUpskillingCallCard";

interface RecruiterScreeningCardProps {
  placementCandidate: PlacementCandidate;
  workplaceType?: string;
}

export function RecruiterScreeningCard(props: RecruiterScreeningCardProps) {
  const { placementCandidate, workplaceType } = props;

  const { showScreeningCard } = usePlacementRecruiterScreeningConfig();
  const hasFailedScreening = placementCandidate.screeningStatus?.startsWith(
    PlacementCandidateScreeningStatus.FAILED
  );

  if (!showScreeningCard) {
    return null;
  }

  // do not show the card if the candidate has passed the screening
  if (placementCandidate.screeningStatus?.startsWith(PlacementCandidateScreeningStatus.PASSED)) {
    return null;
  }

  // Don't show the card if the candidate has booked a meeting, but has not had a decision made yet
  if (placementCandidate.screeningStatus === PlacementCandidateScreeningStatus.PENDING) {
    return (
      <RecruiterBookingFlowProvider placementCandidate={placementCandidate} source="banner">
        <RecruiterScreeningCallCard
          placementCandidate={placementCandidate}
          workplaceType={workplaceType}
        />
      </RecruiterBookingFlowProvider>
    );
  }

  // if the candidate has failed, show the upskilling card
  if (hasFailedScreening) {
    return (
      <RecruiterScreeningUpskillingCallCard
        placementCandidate={placementCandidate}
        workplaceType={workplaceType}
      />
    );
  }

  // if the candidate has not failed (not screened, pending), show the screening card
  return (
    <RecruiterBookingFlowProvider placementCandidate={placementCandidate} source="banner">
      <RecruiterScreeningCallCard
        placementCandidate={placementCandidate}
        workplaceType={workplaceType}
      />
    </RecruiterBookingFlowProvider>
  );
}
